module.exports = __webpack_public_path__ + "static/media/FarmScene-menu.9235cad5.png";